/**
 * Route for `customizable-campaign-alerts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomizableCampaignAlertsPage } from "../features/customizable-campaign-alerts/CustomizableCampaignAlertsPage";

export const customizableCampaignAlertsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/customizable-campaign-alerts",
	component: CustomizableCampaignAlertsPage,
});

export default customizableCampaignAlertsRoute;
